<template>
  <div id="hero" v-if="purl.accounts">
    <div class="hero">
      <div class="left">
        <h1>Welcome {{ purl.firstName }}</h1>
        <div class="clockdown">
          <div class="clockdown_content">
            <div class="clockdown_item">
              <span>{{ `0${timer.days.value}`.slice(-2) }}</span>
              <span>Days</span>
            </div>
            <div class="clockdown_item">
              <span>{{ `0${timer.hours.value}`.slice(-2) }}</span>
              <span>hours</span>
            </div>
            <div class="clockdown_item">
              <span>{{ `0${timer.minutes.value}`.slice(-2) }}</span>
              <span>minutes</span>
            </div>
            <div class="clockdown_item">
              <span>{{ `0${timer.seconds.value}`.slice(-2) }}</span>
              <span>seconds</span>
            </div>
          </div>
        </div>
      </div>
      <div class="hero__player">
        <img
          class="rellax"
          data-rellax-speed="-10"
          src="@/assets/images/hero/hero-player.png"
        />
      </div>
      <img
        class="hero__player-mobile"
        src="@/assets/images/hero/hero-player-mobile.png"
      />
      <div class="right" v-if="$store.state.purl.info.rep">
        <!-- <img src="@/assets/images/hero/placeholder.jpg" /> -->
        <img :src="repSetter($store.state.purl.info.rep.name)" />
        <div class="info">
          <div class="name">{{ $store.state.purl.info.rep.name }}</div>
          <div class="bottom">
            <a
              class="phone"
              :href="'tel:' + $store.state.purl.info.rep.phone"
              target="_blank"
              >{{ $store.state.purl.info.rep.phone }}</a
            >
            <a
              class="email"
              :href="'mailto:' + $store.state.purl.info.rep.email"
              target="_blank"
              >{{ $store.state.purl.info.rep.email }}</a
            >
          </div>
        </div>
      </div>
      <!-- <div class="px-4 py-5 my-5 text-center hero_content">
        <div class="mx-auto">
          <button
            type="button"
            class="btn btn-primary btn-lg px-4 m-3"
            data-bs-toggle="modal"
            data-bs-target="#mainModal"
            @click.prevent="store.dispatch(`modal/setComponentName`, `invoice`)"
          >
            View Invoice
          </button>

          <a
            href="#"
            target="_blank"
            @click="store.dispatch('purl/purlTracking', 'Renew Now')"
          >
            <button type="button" class="btn btn-primary btn-lg px-4">
              Renew my seats!
            </button></a
          >
        </div>
      </div> -->
    </div>
    <TermsConditions
      :modalShow="modalShow"
      @showModal="showModal"
      @closeModal="closeModal"
      :purlData="purl"
    />
  </div>
</template>

<script>
import TermsConditions from "./TermsConditions";
import { reactive, toRefs, computed, watchEffect, onMounted } from "vue";
import { useStore } from "vuex";
import { useTimer } from "vue-timer-hook";
import Rellax from "rellax";

export default {
  name: "Hero",
  components: {
    TermsConditions,
  },
  data() {
    return {
      modalShow: false,
      rellax: {
        speed: -2,
      },
    };
  },
  setup() {
    const store = useStore();
    const time = new Date("March 31, 2022 23:59:59");
    const timer = useTimer(time);

    // State
    const state = reactive({
      accountFirstName: computed(
        () => store.getters["purl/getAccountFirstName"]
      ),
      heroBgSrc: computed(() =>
        store.getters["dom/getTheme"] === "light"
          ? "bgImage.jpeg"
          : "bgImageDark.jpeg"
      ),
      purl: computed(() => store.getters["purl/getAccount"]),
    });
    function getRepAvatar() {
      if (!state.accountRep?.name)
        return require("@/assets/images/avatar.jpeg");

      switch (state.accountRep?.name) {
        case "John Doe":
          return require("@/assets/images/avatar.jpeg");

        default:
          return require("@/assets/images/avatar.jpeg");
      }
    }
    onMounted(() => {
      watchEffect(async () => {
        if (timer.isExpired.value) {
          console.warn("IsExpired");
        }
      });
      var rellax = new Rellax(".rellax", {
        center: false,
      });
    });
    return { ...toRefs(state), store, timer, getRepAvatar };
  },
  mounted() {
    // if (this.$route.path == "/rick.amos.0000") {
    //   this.modalShow = true;
    // } else {
    //   this.modalShow = false;
    // }

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  },
  methods: {
    repSetter(rep) {
      switch (rep) {
        case "Austin Perry":
          return require("@/assets/images/reps/Austin-Perry.png");
        case "Christina McEwan":
          return require("@/assets/images/reps/Christina-McEwan.png");
        case "Emily Stone":
          return require("@/assets/images/reps/Emily-Stone.png");
        case "Josh Kill":
          return require("@/assets/images/reps/Josh-Kill.png");
        case "Samar Shousher":
          return require("@/assets/images/reps/Samar-Shousher.png");
        case "Sarah Richardson":
          return require("@/assets/images/reps/Sarah-Richardson.png");
        case "Rashii Givens":
          return require("@/assets/images/reps/Rashii-Givens.png");
        case "Amber Myczkowiak":
          return require("@/assets/images/reps/Amber-M.png");
        default:
          return require("@/assets/images/reps/avatar.jpeg");
      }
    },
    showModal() {
      this.modalShow = true;
    },
    closeModal() {
      this.modalShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
#hero {
  margin: 0;
  width: 100vw;
}
.hero {
  position: relative;
  background-image: url("~images/hero/hero-bg.jpg");
  background-position: bottom right;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  overflow: hidden;
  width: 100vw;
  height: calc(100vw / 16 * 9);
  max-height: 100vh;
  @media (max-width: 992px) {
    background-image: url("~images/hero/hero-bg-mobile.jpg");
    flex-direction: column;
    padding-top: 119px;
    // height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    align-items: center;
  }
  .left {
    position: relative;
    display: flex;
    flex-direction: column;
    z-index: 2;
    h1 {
      font-family: Birdrockers;
      font-weight: normal;
      font-size: 48px;
      line-height: 48px;
      letter-spacing: normal;
      text-rendering: optimizeLegibility;
      color: #ffffff;
      margin-left: 32px;
      margin-bottom: 21px;
      @media (max-width: 992px) {
        font-size: 30px;
        line-height: 30px;
        margin-left: 0;
      }
    }

    .clockdown {
      position: relative;
      @media (max-width: 992px) {
      }
      &_content {
        display: flex;
        justify-content: flex-start;
        margin: auto;
        padding: 20px 15px;
        background: url("~@/assets/images/hero/timer-bg.jpg");
        background-size: cover;
        background-repeat: no-repeat;
      }

      &_item {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 15px;
        span:first-child {
          font-family: DINPro;
          font-weight: 900;
          font-size: 58px;
          line-height: 52px;
          letter-spacing: -1px;
          color: #0d243f;
          margin-bottom: 12px;
          @include media-breakpoint-down(md) {
            font-size: 46px;
            line-height: 42.44px;
          }
          // @include media-breakpoint-down(sm) {
          //   font-size: 40px;
          //   line-height: 40px;
          // }
        }
        span:last-child {
          font-family: Abolition-Rough;
          font-size: 21px;
          line-height: 20px;
          font-style: normal;
          letter-spacing: 0;
          color: #0d243f;
          text-transform: uppercase;
          @include media-breakpoint-down(md) {
            font-size: 18px;
            line-height: 16.32px;
          }
        }
      }
    }
  }
  &__player {
    position: absolute;
    bottom: -9%;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
    img {
      height: 100%;
      object-fit: contain;
    }
    @media (max-width: 992px) {
      display: none;
    }
    &-mobile {
      position: absolute;
      bottom: 0;
      height: 56%;
      object-fit: contain;
      @media (min-width: 992px) {
        display: none;
      }
    }
  }
  .right {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 68px;
    min-width: 372px;
    background: url("~@/assets/images/hero/texturted-bg.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    padding-right: 24px;
    z-index: 2;
    @media (max-width: 992px) {
      justify-content: center;
      width: 100%;
    }
    img {
      height: 100%;
      object-fit: contain;
      margin-right: 11px;
    }
    .info {
      display: flex;
      flex-direction: column;
      .name {
        font-family: Abolition;
        font-weight: normal;
        font-size: 20px;
        line-height: 20px;
        letter-spacing: normal;
        color: #0d243f;
        margin-bottom: 5px;
      }
      .bottom {
        display: flex;
        flex-direction: row;

        a {
          font-family: Abolition;
          font-weight: normal;
          font-size: 20px;
          line-height: 20px;
          letter-spacing: normal;
          color: #de1e35;
          text-decoration: none;
          &.phone {
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>
